// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaArrowLeft } from 'react-icons/fa';

const PageHeader = ({ showBackButton = false, backTo = "/" }) => {
  return (
    <nav className="bg-white shadow-sm py-4 sticky top-0 z-50">
      <div className="container mx-auto px-6 flex justify-between items-center">
       <Link to="/" className="flex items-center gap-2">
         {/* Replace with your desired icon */}
         <img
           src="/logo1.png" // your icon path
           alt="Logo Icon"
           className="h-14 w-36 rounded-xl "
         />
       
       </Link>

        {showBackButton && (
          <Link to={backTo} className="flex items-center text-gray-600 hover:text-rose-600 font-medium">
            <FaArrowLeft className="mr-2" /> Back to Home
          </Link>
        )}
      </div>
    </nav>
  );
};

export default PageHeader;